import React,{useState} from 'react';
import './preview-login.css';

export default function PreviewLogin({onSession}){
  const [busy,setBusy]=useState(null),[error,setError]=useState('');
  async function login(role){
    if(busy)return;
    setBusy(role);setError('');
    try{
      let identity=localStorage.getItem('wiki-preview-identity');
      if(!identity){identity=crypto.randomUUID();localStorage.setItem('wiki-preview-identity',identity);}
      const response=await fetch('/auth/preview',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({role,identity})});
      const data=await response.json();if(!response.ok)throw new Error(data.error||'測試登入失敗。');
      await onSession(data.session);
    }catch(e){setError(e.message||'無法登入，請再試一次。');}finally{setBusy(null);}
  }
  return <section className="preview-login" aria-label="選擇測試身分">
    <p>選擇身分即可測試，操作只影響預覽站。</p>
    <div className="preview-roles">{[['admin','管理員','管理成員與編輯權限'],['editor','共編者','編輯條目、討論與 AI'],['member','評論者','提出譯名、投票與討論']].map(([role,label,description])=><button key={role} onClick={()=>login(role)} disabled={Boolean(busy)}><strong>{busy===role?'登入中…':label}</strong><span>{description}</span></button>)}</div>
    {error&&<p role="alert">{error}</p>}
  </section>;
}
